import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CONVENIOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    cancelarEvento(id) {
        return axiosJwt
            .get(`${api}/convenios/cancelarevento/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirEvento(evento) {
        return axiosJwt
            .post(`${api}/convenios/inserirevento`, evento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    alterarEvento(evento) {
        return axiosJwt
            .post(`${api}/convenios/alterarevento`, evento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDocumentosEvento(idEvento) {
        return axiosJwt
            .get(`${api}/convenios/obterdocumentosevento/${idEvento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDocumentoEvento(documento) {
        const formData = new FormData()
        formData.append('idEvento', documento.idEvento)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)
        formData.append('descricaoArquivo', documento.descricaoArquivo)

        return axiosJwt
            .post(`${api}/convenios/inserirdocumentoevento`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDocumentoEvento(idDocumentoEvento) {
        return axiosJwt
            .get(`${api}/convenios/excluirdocumentoevento/${idDocumentoEvento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumentoEvento(idEvento, idDocumento) {
        return axiosJwt
            .get(
                `${api}/convenios/downloaddocumentoevento/${idEvento}/${idDocumento}`,
                { responseType: 'blob' }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterMetas(idEvento) {
        return axiosJwt
            .get(`${api}/convenios/${idEvento}/obtermetas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    cancelarMeta(idMeta) {
        return axiosJwt
            .get(`${api}/convenios/cancelarmeta/${idMeta}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirMeta(meta) {
        return axiosJwt
            .post(`${api}/convenios/inserirmeta`, meta)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposInstrumento() {
        return axiosJwt
            .get(`${api}/convenios/obtertiposinstrumento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
